import { useId } from "react";

import { cn } from "@/lib/utils";

export default function RobotHeroIcon2({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[812px] w-[375px]", className)}
      fill="none"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 375 812"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id}-a)`}>
        <path d="M0 0h375v812H0z" fill="#fff" />
        <path d="M-3108.5 0H2943v737.145h-6051.5z" fill={`url(#${id}-b)`} />
        <g filter={`url(#${id}-c)`}>
          <ellipse
            cx="-710.106"
            cy="420.457"
            fill="#3E2AA3"
            rx="706.417"
            ry="689.108"
          />
        </g>
        <g filter={`url(#${id}-d)`}>
          <ellipse
            cx="298.48"
            cy="218.475"
            fill="#4994D7"
            rx="572.347"
            ry="572.237"
          />
        </g>
        <path
          d="M76.98 373.608a4.856 4.856 0 109.713 0 4.856 4.856 0 00-9.712 0z"
          fill={`url(#${id}-e)`}
        />
        <path
          d="M-33.922 397.108a4.012 4.012 0 108.024 0 4.012 4.012 0 00-8.024 0z"
          fill={`url(#${id}-f)`}
        />
        <path
          d="M113.821 335.509a2.832 2.832 0 105.665 0 2.832 2.832 0 00-5.665 0z"
          fill={`url(#${id}-g)`}
        />
        <path
          d="M-83.957 299.871a3.54 3.54 0 107.08 0 3.54 3.54 0 00-7.08 0z"
          fill={`url(#${id}-h)`}
        />
        <path
          d="M-155.91 255.604a4.248 4.248 0 108.496 0 4.248 4.248 0 00-8.496 0z"
          fill={`url(#${id}-i)`}
        />
        <path
          d="M-125.284 151.184a3.541 3.541 0 107.082-.002 3.541 3.541 0 00-7.082.002z"
          fill={`url(#${id}-j)`}
        />
        <path
          d="M-13.904 107.714a2.36 2.36 0 104.72 0 2.36 2.36 0 00-4.72 0z"
          fill={`url(#${id}-k)`}
        />
        <path
          d="M-138.518 66.411a3.068 3.068 0 106.135.001 3.068 3.068 0 00-6.135 0z"
          fill={`url(#${id}-l)`}
        />
        <path
          d="M50.57 209.522a2.597 2.597 0 105.193-.001 2.597 2.597 0 00-5.193.001z"
          fill={`url(#${id}-m)`}
        />
        <path
          d="M154.822 149.273a3.282 3.282 0 106.564 0 3.282 3.282 0 00-6.564 0z"
          fill={`url(#${id}-n)`}
        />
        <path
          d="M52.228 149.02a3.535 3.535 0 107.07 0 3.535 3.535 0 00-7.07 0z"
          fill={`url(#${id}-o)`}
        />
        <path
          d="M-183.054 400.781a3.668 3.668 0 107.337 0 3.668 3.668 0 00-7.337 0z"
          fill={`url(#${id}-p)`}
        />
        <path
          d="M-240.606 191.52a3.283 3.283 0 106.567.001 3.283 3.283 0 00-6.567-.001z"
          fill={`url(#${id}-q)`}
        />
        <path
          d="M-270.75 66.693a3.35 3.35 0 106.7 0 3.35 3.35 0 00-6.7 0z"
          fill={`url(#${id}-r)`}
        />
        <path
          d="M-298.066 445.626a5.952 5.952 0 1011.903 0 5.952 5.952 0 00-11.903 0z"
          fill={`url(#${id}-s)`}
        />
        <path
          d="M645.66 373.608a4.856 4.856 0 109.712 0 4.856 4.856 0 00-9.712 0z"
          fill={`url(#${id}-t)`}
        />
        <path
          d="M534.757 397.108a4.012 4.012 0 108.023 0 4.012 4.012 0 00-8.023 0z"
          fill={`url(#${id}-u)`}
        />
        <path
          d="M682.5 335.509a2.833 2.833 0 105.666-.002 2.833 2.833 0 00-5.666.002z"
          fill={`url(#${id}-v)`}
        />
        <path
          d="M484.722 299.871a3.54 3.54 0 107.08 0 3.54 3.54 0 00-7.08 0z"
          fill={`url(#${id}-w)`}
        />
        <path
          d="M412.769 255.604a4.248 4.248 0 108.496 0 4.248 4.248 0 00-8.496 0z"
          fill={`url(#${id}-x)`}
        />
        <path
          d="M421.191 183.753a4.485 4.485 0 108.97-.002 4.485 4.485 0 00-8.97.002z"
          fill={`url(#${id}-y)`}
        />
        <path
          d="M491.802 151.184a3.54 3.54 0 107.08 0 3.54 3.54 0 00-7.08 0z"
          fill={`url(#${id}-z)`}
        />
        <path
          d="M530.509 238.992a4.13 4.13 0 108.26 0 4.13 4.13 0 00-8.26 0z"
          fill={`url(#${id}-A)`}
        />
        <path
          d="M554.774 107.714a2.36 2.36 0 104.721-.001 2.36 2.36 0 00-4.721.001z"
          fill={`url(#${id}-B)`}
        />
        <path
          d="M356.845 149.059a3.069 3.069 0 106.137-.001 3.069 3.069 0 00-6.137.001z"
          fill={`url(#${id}-C)`}
        />
        <path
          d="M619.249 209.522a2.596 2.596 0 105.193 0 2.596 2.596 0 00-5.193 0z"
          fill={`url(#${id}-D)`}
        />
        <path
          d="M723.501 149.273a3.282 3.282 0 106.564 0 3.282 3.282 0 00-6.564 0z"
          fill={`url(#${id}-E)`}
        />
        <path
          d="M685.127 15.732a3.535 3.535 0 107.07-.001 3.535 3.535 0 00-7.07 0z"
          fill={`url(#${id}-F)`}
        />
        <path
          d="M385.626 400.781a3.668 3.668 0 107.335.001 3.668 3.668 0 00-7.335-.001z"
          fill={`url(#${id}-G)`}
        />
        <path
          d="M328.073 191.52a3.283 3.283 0 106.567.001 3.283 3.283 0 00-6.567-.001z"
          fill={`url(#${id}-H)`}
        />
        <path
          d="M246.49 267.397a3.444 3.444 0 106.888 0 3.444 3.444 0 00-6.888 0z"
          fill={`url(#${id}-I)`}
        />
        <path
          d="M220.614 161.655a2.511 2.511 0 105.024 0 2.512 2.512 0 00-5.024 0z"
          fill={`url(#${id}-J)`}
        />
        <path
          d="M297.929 66.693a3.35 3.35 0 106.7 0 3.35 3.35 0 00-6.7 0z"
          fill={`url(#${id}-K)`}
        />
        <path
          d="M270.613 445.626a5.952 5.952 0 1011.903 0 5.952 5.952 0 00-11.903 0z"
          fill={`url(#${id}-L)`}
        />
        <path
          clipRule="evenodd"
          d="M-288.482 225.361l401.671-1.823 697.137-3.177 49.774-.222 38.184-.394 90.133-.912c-14.449-4.483-37.274-9.878-64.061-12.489-34.806-3.399-76.334-2.118-114.939 12.021-.163-.172-.325-.345-.52-.492-6.136-6.06-12.565-10.888-19.124-14.706-48.995-28.723-105.718-1.552-113.056 2.192-.552.271-.812.419-.812.419s.065-.468.162-1.355c.163-1.33.358-3.572.423-6.429.097-4.434-.065-10.346-1.104-16.628-2.403-13.795-9.189-29.387-27.177-34.881-28.183-8.621-55.521 21.308-70.003 41.089-6.656 9.114-10.584 16.085-10.584 16.085s0-3.375-1.396-8.695c-4.708-18.081-43.295-88.854-145.938-88.854-102.643 0-127.72 62.383-165.178 110.851l-51.691-11.183-2.142-.444c-52.243-10.321-150.201 5.346-150.201 5.346s-18.605-18.796-71.561-21.086c-52.957-2.316-129.128 29.239-129.128 29.239-72.503-3.744-138.869 6.528-138.869 6.528z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.5"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M342.343 627.704H-660.059l399.408-436.032 48.018 16.918 80.081 72.573 85.396-50.037 389.499 396.578z"
          fill={`url(#${id}-M)`}
        />
        <path
          d="M-197.786 876.471c62.438-28.744 28.963 44.638 0 0-26.424-40.725 104.747 12.026 0 0-38.765-4.45 7.228 2.741 0 0-16.784-6.363-216.963-271.039-327.951-307.972l29.045-17.041s873.313-9.194 1420.294 31.642c546.978 40.837 1711.428 430.3 1711.428 430.3l-691.76-163.874-2100.935 33.113-40.121-6.168z"
          fill="#4E4288"
        />
        <path
          clipRule="evenodd"
          d="M1432.65 857.574l-33.98-8.048-1599.058 25.203c-7.109-5.883-23.967-25.284-46.936-51.719-70.3-80.906-197.852-227.703-278.413-254.511l27.501-16.135c279.602 3.124 615.722 11.212 877.244 30.736 310.998 23.219 821.602 159.14 1204.302 272.1l-150.66 2.374z"
          fill="#4E6EC0"
          fillRule="evenodd"
        />
        <ellipse
          cx="453.787"
          cy="616.953"
          fill={`url(#${id}-N)`}
          rx="178.909"
          ry="10.997"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          clipRule="evenodd"
          d="M217.321 607.852l-40.611.147-324.151 1.189-64.978.239-132.218.484-31.938.117-18 .067-68.517.246-26.02.098a196.664 196.664 0 0119.29-4.027c36.811-5.811 68.01-.466 78.467 1.759a89.87 89.87 0 013.757.87s1.261-1.943 4.742-4.094c2.814-1.766 7.122-3.666 13.402-4.763 10.545-1.845 21.321-.031 27.804 1.539 3.757.913 6.063 1.746 6.063 1.746s-.914-2.647-1.349-5.829c-.551-4.051-.304-8.979 3.641-10.413 7.02-2.556 16.056 0 16.056 0s12.053-18.088 41.177-20.846c27.847-2.63 50.184 2.292 52.084 2.733a1.2 1.2 0 01.13.025c.131-.141.261-.288.392-.429a45.85 45.85 0 012.117-2.188c0-.013.029-.031.044-.043a58.526 58.526 0 016.033-5.118c12.706-9.39 33.171-16.96 63.717-14.594 41.51 3.211 46.616 26.154 46.616 26.154 47.283-8.778 83.934 7.226 83.934 7.226s19.073-2.923 37.16 2.93c9.689 3.132 13.315 8.587 14.59 12.982.407 1.373.581 2.648.625 3.708.536-.87 1.639-1.747 3.742-2.372.029-.012.072-.024.116-.036 6.033-1.723 16.07-.687 16.07-.687v-.012c-.058-.264-.928-4.456.783-9.476 2.597-7.601 11.11-17.089 37.377-17.702 28.24-.662 60.598 12.988 80.251 22.924 7.165 3.616 12.633 6.736 15.606 8.495a99 99 0 012.553 1.533c14.084-5.596 29.443 5.418 29.443 5.418z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.7"
          style={{ mixBlendMode: "soft-light" }}
        />
        <ellipse
          cx="216.835"
          cy="748.978"
          fill={`url(#${id}-O)`}
          rx="105.369"
          ry="6.417"
          style={{ mixBlendMode: "multiply" }}
        />
        <g filter={`url(#${id}-P)`}>
          <path
            d="M203.259 689.766l-14.349 10.083c3.943.97 12.333 3.103 14.349 3.879 2.521.969 10.859 8.531 14.155 8.531 2.638 0 10.148-6.98 13.574-10.471l-7.175.97c.13.776-.969 2.792-6.399 4.654-5.429 1.861-10.277-2.973-12.022-5.624l-11.052-3.102 12.41-8.92 2.714-4.46 4.654-4.653-7.368 3.684-3.491 5.429z"
            fill="#2AF5C4"
          />
        </g>
        <path
          d="M183.083 637.946l1.277 1.817c3.789 5.391 11.225 6.701 16.627 2.93l6.8-4.747"
          stroke="#4D0D54"
          strokeLinecap="round"
          strokeWidth="13.152"
        />
        <path
          d="M216.685 617.648l-21.943 20.128a17.782 17.782 0 0011.565 12.774l.222.076 21.943-20.129.023-.167c.98-7.018-4.741-13.161-11.81-12.682z"
          fill={`url(#${id}-Q)`}
        />
        <path
          d="M220.555 637.945l-.219-.074a17.513 17.513 0 01-11.39-12.581"
          stroke="#FFFBFB"
          strokeLinecap="round"
          strokeWidth="5.299"
        />
        <path
          clipRule="evenodd"
          d="M216.523 617.796a13.826 13.826 0 0011.732 12.289l.3-.275c.635-6.798-4.976-12.629-11.87-12.162l-.162.148z"
          fill="#A3551B"
          fillRule="evenodd"
        />
        <rect
          fill="#E48E48"
          height="11.022"
          rx="1.887"
          transform="scale(-1 1) rotate(-77.717 269.83 460.087)"
          width="3.774"
        />
        <rect
          fill="#A3551B"
          height="11.022"
          rx="1.887"
          transform="scale(-1 1) rotate(-39.079 751.136 635.586)"
          width="3.774"
        />
        <rect
          fill="#E48E48"
          height="11.022"
          rx="1.887"
          transform="scale(-1 1) rotate(.71 -49417.042 -17655.061)"
          width="3.774"
        />
        <path
          d="M234.002 626.544l-.782-3.593m-10.569-8.647l-3.677.046m11.266 13.013l-.782-3.593m-6.759-5.616l-3.677.046"
          stroke="#A3551B"
          strokeWidth="1.196"
        />
        <rect
          fill="#F39D42"
          height="11.022"
          rx="1.887"
          transform="scale(1 -1) rotate(-53.65 -506.682 -530.353)"
          width="3.774"
        />
        <path
          d="M122.62 637.946l-1.277 1.817c-3.789 5.391-11.224 6.701-16.627 2.93l-6.8-4.747"
          stroke="#4D0D54"
          strokeLinecap="round"
          strokeWidth="13.152"
        />
        <path
          d="M92.153 617.648l21.943 20.128a17.778 17.778 0 01-11.565 12.774l-.222.076-21.943-20.129-.023-.167c-.98-7.018 4.741-13.161 11.81-12.682z"
          fill={`url(#${id}-R)`}
        />
        <path
          d="M89.098 638.445l.22-.075a17.509 17.509 0 0011.389-12.58"
          stroke="#FFFBFB"
          strokeLinecap="round"
          strokeWidth="5.299"
        />
        <path
          clipRule="evenodd"
          d="M92.314 617.796a13.825 13.825 0 01-11.731 12.289l-.3-.275c-.635-6.798 4.976-12.629 11.87-12.162l.161.148z"
          fill="#A3551B"
          fillRule="evenodd"
        />
        <path
          d="M143.498 678.915l-7.404 57.182"
          stroke="#4D0D54"
          strokeWidth="13.152"
        />
        <path
          d="M129.719 730.241c9.161-6.521 14.038-2.717 15.332 0l-1.359 16.69h-18.436c-1.087-6.521 2.523-13.844 4.463-16.69z"
          fill={`url(#${id}-S)`}
        />
        <path
          d="M168.288 678.65l10.583 26.78V735m-19.933-88.986l-1.202 32.243"
          stroke="#4D0D54"
          strokeLinecap="round"
          strokeWidth="13.152"
        />
        <ellipse
          cx="159.311"
          cy="653.795"
          fill="#A3551B"
          rx="18.808"
          ry="15.012"
        />
        <path
          d="M172.875 729.607c9.16-6.521 14.037-2.717 15.331 0l-1.359 16.69h-18.436c-1.087-6.521 2.523-13.844 4.464-16.69z"
          fill={`url(#${id}-T)`}
        />
        <path
          d="M174.179 635.213l1.84 3.266c1.795 3.184 6.001 4.027 8.884 1.78l2.694-2.1c1.963-1.529 2.461-4.344.868-6.256-4.575-5.491-8.693-6.582-11.886-5.984-3.99.748-4.394 5.757-2.4 9.294z"
          fill="#A3551B"
        />
        <path
          d="M176.887 679.849c-2.223-4.082-6.27-5.31-8.016-5.413l6.262 16.006a3.759 3.759 0 004.87 2.131l1.615-.632c-.651-2.329-2.508-8.01-4.731-12.092z"
          fill={`url(#${id}-U)`}
        />
        <path
          d="M174.339 619.445h-39.717c-2.707 0-4.987 2.062-5.149 4.764-.932 15.593 1.666 24.595 3.794 29.204 1.273 2.757 4.176 4.032 7.213 4.032h35.204c2.413 0 4.889-.679 6.377-2.578 6.778-8.655 1.496-23.906-3.299-32.855-.868-1.619-2.585-2.567-4.423-2.567z"
          fill={`url(#${id}-V)`}
        />
        <path
          clipRule="evenodd"
          d="M179.837 656.191l-3.017-9.897a2.648 2.648 0 00-2.534-1.877h-23.781a2.649 2.649 0 00-2.516 1.818l-3.705 11.21h5.582l2.554-7.729h19.903l2.346 7.695c1.808-.106 3.616-.469 5.168-1.22zm-36.799-36.746c.273.458.562.974.854 1.531 2.451 4.68 7.038 9.073 12.32 9.073h4.924c5.283 0 9.645-4.375 8.04-9.408-.127-.4-.264-.799-.411-1.196h-25.727z"
          fill="#A3551B"
          fillRule="evenodd"
        />
        <rect
          fill="#4D0D54"
          height="14.988"
          rx="4.042"
          width="8.084"
          x="153.738"
          y="611.12"
        />
        <rect
          fill="#FFFBFB"
          height="14.988"
          rx="2.051"
          transform="rotate(30 152.052 611.768)"
          width="4.103"
          x="152.052"
          y="611.768"
        />
        <rect
          fill="#FFFBFB"
          height="14.988"
          rx="2.051"
          transform="scale(-1 1) rotate(30 -1223.179 1.334)"
          width="4.103"
        />
        <path
          d="M154.652 595.619c13.19 1.826 14.677 16.791 13.715 24.238h-13.88l-10.752-10.426c-1.482-3.765-1.348-6.696-.502-8.878 1.64-4.232 6.923-5.556 11.419-4.934z"
          fill="#4D0D54"
        />
        <path
          d="M147.04 588.638c21.506-3.32 23.863 17.122 22.641 26.577h-15.309l-11.86-11.5c-3.622-9.199 1.51-13.884 4.528-15.077z"
          fill={`url(#${id}-W)`}
        />
        <path
          d="M158.051 613.033v2.073m2.447-2.073v2.073m2.447-2.073v2.073m2.447-2.073v2.073"
          stroke="#FFFBFB"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
        <path
          clipRule="evenodd"
          d="M141.922 594.019c5.561 2.51 9.921 11.626 10.597 19.4l-10.007-9.704c-1.613-4.097-1.49-7.299-.59-9.696zm-8.535 26.473c-2.328 1.297-3.947 3.685-4.046 6.524-.398 11.481 1.184 19.071 2.872 23.8.863 2.414 2.568 4.133 4.7 5.214 1.288-.684 2.378-1.655 3.114-2.993 4.573-8.316.518-21.042-3.701-29.471a7.278 7.278 0 00-2.939-3.074z"
          fill="#A3551B"
          fillRule="evenodd"
        />
        <path
          d="M134.392 633.021l-4.342 7.703a3.758 3.758 0 01-5.585 1.119l-6.016-4.689c-1.234-.961-1.533-2.725-.591-3.974 6.234-8.262 11.705-8.224 15.275-6.458 2.288 1.132 2.512 4.075 1.259 6.299z"
          fill={`url(#${id}-X)`}
        />
        <path
          d="M143.667 674.404c6.697-.598 26.189 0 26.189 0 0 18.117-26.189 18.834-26.189 0z"
          fill="#A3551B"
        />
        <path
          clipRule="evenodd"
          d="M150.677 674.15c-2.807.028-5.317.102-7.01.254 0 7.931 4.645 12.396 10.022 13.553 5.529-1.177 10.384-5.752 10.384-13.553 0 0-6.573-.202-13.396-.254z"
          fill={`url(#${id}-Y)`}
          fillRule="evenodd"
        />
        <path
          d="M141.752 674.109c1.306-.34 2.374.3 3.218 1.373 2.635 3.35 1.851 8.181.126 12.079-4.809 10.866-9.791 8.236-10.878 4.665-1.256-4.125 3.408-17.04 7.534-18.117z"
          fill="#A3551B"
        />
        <path
          clipRule="evenodd"
          d="M142.324 674.02c.133.137.26.284.383.44 2.636 3.35 1.852 8.182.127 12.079-2.629 5.941-5.31 7.847-7.378 7.772-.572-.56-.999-1.3-1.238-2.085-1.256-4.125 3.408-17.041 7.534-18.117.196-.051.386-.08.572-.089z"
          fill={`url(#${id}-Z)`}
          fillRule="evenodd"
        />
        <rect
          fill="#F39D42"
          height="11.022"
          rx="1.887"
          transform="rotate(-77.717 70.992 624.842)"
          width="3.774"
          x="70.992"
          y="624.842"
        />
        <rect
          fill="#A3551B"
          height="11.022"
          rx="1.887"
          transform="rotate(-39.079 75.499 614.682)"
          width="3.774"
          x="75.499"
          y="614.682"
        />
        <rect
          fill="#F39D42"
          height="11.022"
          rx="1.887"
          transform="rotate(.71 85.514 610.086)"
          width="3.774"
          x="85.514"
          y="610.086"
        />
        <path
          d="M74.12 625.527l.781-3.594m10.568-8.646l3.677.045m-11.264 13.014l.782-3.593m6.758-5.616l3.677.046"
          stroke="#A3551B"
          strokeWidth="1.196"
        />
        <rect
          fill="#F39D42"
          height="11.022"
          rx="1.887"
          transform="rotate(126.35 87.332 623.073)"
          width="3.774"
          x="87.332"
          y="623.073"
        />
        <circle cx="139.906" cy="706.399" fill={`url(#${id}-aa)`} r="7.407" />
        <circle cx="178.209" cy="706.399" fill={`url(#${id}-ab)`} r="7.407" />
        <circle cx="155.241" cy="606.984" fill="#FFFBFB" r="1.76" />
        <path
          d="M153.111 605.224l3.89.66m11.461-1.319l-3.889.659"
          stroke="#FFFBFB"
          strokeLinecap="round"
          strokeWidth="1.957"
        />
        <circle cx="166.517" cy="606.232" fill="#FFFBFB" r="1.76" />
        <path
          d="M168.211 746.297h21.496a1.737 1.737 0 010 3.474h-21.496v-3.474zm-45.816 1.737c0-.959.777-1.737 1.736-1.737h19.759a1.737 1.737 0 110 3.474h-19.759a1.737 1.737 0 01-1.736-1.737z"
          fill="#4D0D54"
        />
        <rect
          fill="#FFFBFB"
          height="2.778"
          rx="1.389"
          width="9.587"
          x="142.044"
          y="636.801"
        />
        <rect
          fill="#FFFBFB"
          height="2.778"
          rx="1.389"
          width="9.587"
          x="176.624"
          y="636.801"
        />
        <g filter={`url(#${id}-ac)`}>
          <path
            d="M110.189 692.289c-3.626-1.494-12.71-.622-16.8 0 2.9-5.213 13.205-3.333 18.464-3.826 4.207-.394 7.121-11.777 8.052-17.419 2.027.415 6.08-.943 6.08-9.696 0-8.752-18.624-29.611-27.936-38.946l5.423 1.643c.383-4.601.657-14.198-1.315-15.776-1.972-1.577-12.653-7.669-17.748-10.517v-7.724c1.26-.767 4.536-2.3 7.56-2.3 3.78 0 32.209-13.804 44.862-13.804 10.123 0 27.005-8.545 34.181-12.818-1.315 8.874 4.145 20.541 10.517 22.678 5.098 1.709 13.518-.712 17.091-2.137 7.544 0 22.805-5.712 30.399-8.941.416-.453.751-.55.988-.425-.312.136-.642.278-.988.425-1.414 1.535-3.767 7.162-6.407 22.088-3.418 19.325-19.391 30.292-26.95 33.359 2.33 3.65 2.943 14.229 2.958 19.063 17.353 14.067 20.267 30.839 19.555 37.468-.131-17.091-15.063-31.552-22.513-36.646 0-6.705-4.601-18.789-6.902-23.993 25.964-.986 35.66-38.454 33.852-42.398-1.446-3.155-9.476.11-13.311 2.137-9.859-.658-19.774 8.381-23.499 12.982-1.643-5.094-11.668-17.584-19.063-22.842-5.915-4.207-12.324-.438-14.789 1.972-1.206.383-6.146 1.15-16.269 1.15-10.123 0-25.91 7.779-32.538 11.668-4.492.821-13.31 3.549-12.653 7.888.657 4.338 9.695 5.313 14.132 5.258 0 3.616 1.972 20.87 1.972 23.335 0 1.972 13.585 19.775 20.377 28.43 1.606.266 5.139 1.81 6.419 5.864 1.28 4.053-6.4 10.222-10.4 12.8-2.756 7.289-9.174 21.493-12.801 20z"
            fill="#2AF5C4"
          />
        </g>
        <g filter={`url(#${id}-ad)`}>
          <path
            d="M60.503 599.306l-.545 3.17c2.365-3.473 5.827-4.718 7.262-4.907l.71-4.367-1.496-1.62c-8.234.76-9.327-1.874-13.917-6.721-4.59-4.846-3.253-20.259 7.633-21.623 8.708-1.09 13.829 4.546 15.301 7.501-.303-2.311-4.414-8.396-6.077-9.673-1.664-1.277-13.725-5.25-15.441-4.491-1.374.608-4.972 8.524-6.599 12.406l1.297 16.391 8.165 9.292 3.886-.51c5.443 3.046 2.149 4.704-.179 5.152z"
            fill="#2AF5C4"
          />
        </g>
        <g filter={`url(#${id}-ae)`}>
          <path
            d="M257.362 581.027c-.858 9.201-9.532 10.81-14.943 10.307 2.055 2.255 5.304 2.802 6.672 2.793 2.369-2.654 9.304-6.621 12.475-8.274.815-2.049 1.993-6.644.185-8.628s-5.042-12.325-6.433-17.248l-8.713-2.995c7.596 3.807 11.831 12.543 10.757 24.045z"
            fill="#2AF5C4"
          />
        </g>
        <path
          d="M495.689 569.225h12.171l6.243 13.793-45.897 34.151H307.903v-33.744l37.673-6.665v-13.91l35.355-14.78h16.808l2.608 10.723 19.706-3.478 8.114-12.171h21.445v15.649l22.314 4.057v13.91h16.808l3.478-21.445h5.216l-1.739 13.91z"
          fill="#4D0D54"
        />
        <path
          clipRule="evenodd"
          d="M522.488 616.953l4.793-75.09h-23.136L500.55 584.6h-26.791v-47.53h7.589l4.394-23.319H432.22v-29.004h-27.56v29.165H303.552v19.498h46.229v52.318h-46.229v-33.601h-21.649l1.491 64.826h138.409l4.975-79.883h34.491l-3.573 79.883h64.792zm-108.221-84.82h-31.589v54.828h29.106l2.483-54.828z"
          fill={`url(#${id}-af)`}
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M529.86 616.953l4.793-75.09h-23.136l-3.595 42.737h-26.791v-47.53h7.589l4.394-23.319h-53.522v-29.004h-27.559v29.165h-54.88v103.041h72.022l4.975-79.883h34.491l-3.573 79.883h64.792zm-108.221-84.82H390.05v54.828h29.106l2.483-54.828z"
          fill="#962760"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M60.71 821.988l-7.297-13.621H23.36l-10.02-16.696h-37.4c-2.449-6.234-8.415-19.235-12.69-21.372-4.274-2.137-43.634-3.562-62.78-4.007l27.383-6.679-22.707-24.711h-48.087l30.722-6.679-22.421-18.522 2.359.627v-21.526l27.645 21.526v9.355l51.454 21.829v16.372l68.606 4.678 20.27 23.388h28.845l5.707 22.77h36.574v13.268H60.71z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M60.682 821.988h-386.935v-44.483h-16.628l-6.097-19.621h26.051v-13.08h-14.411v-22.171h29.931l13.302-25.496h16.074l6.097-29.931h71.5l39.353 21.597v13.876l26.413 7.022 22.422 18.522-30.722 6.679h48.086l22.708 24.711-27.383 6.679c19.146.445 58.506 1.87 62.78 4.007 4.275 2.137 10.24 15.138 12.69 21.372h37.4l10.018 16.696h30.055l7.296 13.621zm-192.99-111.66v-21.525 21.525z"
          fill={`url(#${id}-ag)`}
          fillRule="evenodd"
        />
        <ellipse
          cx="330"
          cy="680.572"
          fill={`url(#${id}-ah)`}
          rx="36.861"
          ry="4.715"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          clipRule="evenodd"
          d="M300.315 670.482a1.083 1.083 0 00-.064-.386c-.688-1.96-.983-6.838 2.954-12.184 5.085-6.907 17.792-7.461 23.3-1.366 5.508 6.095 8.32 18.418-1.063 23.679-3.084 1.729-6.548 2.165-8.43 1.223-.314-.158-.753.003-.809.35a.433.433 0 01-.168.277 11.21 11.21 0 01-1.87 1.123c-.62.294-1.275-.225-1.213-.908l.162-1.789a.72.72 0 10-1.433-.131l-.272 2.989c-.039.432-.365.789-.797.831-.142.014-.285.024-.428.032-.543.029-.957-.449-.907-.991l.279-3.075a.72.72 0 10-1.434-.13l-.275 3.031c-.048.527-.544.9-1.048.736a.835.835 0 01-.558-.879l.293-3.217a.72.72 0 00-1.434-.13l-.204 2.237c-.043.477-.57.735-.94.431a.62.62 0 01-.22-.535l.311-3.418a.72.72 0 00-1.434-.131l-.065.71c-.055.604-.787.802-1.068.264a.662.662 0 01-.071-.373c.12-1.129.321-3.145.301-3.51-.01-.166-.195-.458-.442-.775-.608-.782-1.018-1.717-.989-2.707l.036-1.278z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M327.649 657.954c4.705 6.424 6.501 17.389-2.207 22.271-3.084 1.729-6.548 2.165-8.43 1.223a.603.603 0 00-.389-.048c-.137-2.953 1.937-3.544 4.855-4.376l.188-.054c3.12-.891 3.098-6.827 3.078-12.054a246.57 246.57 0 01-.003-1.208c0-3.09 1.497-4.864 2.908-5.754z"
          fill="#CCDAFF"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M302.247 663.917c.442-.765 1.015-1.136 1.584-1.278 1.273-.318 2.219.888 2.072 2.192-.042.367-.098.713-.148.968-.813 6.032-2.61 6.374-3.936 5.347-1.326-1.026-.855-5.004.428-7.229zm12.311-.253c-1.901 0-2.145.983-2.334 2.709l-.026.236c-.181 1.635-.348 3.153.213 5.227.589 2.172 6.081 4.408 6.733-1.544.333-3.043-2.21-6.628-4.586-6.628zm-9.128 10.746c.44-1.629 1.486-4.933 2.155-5.113.836-.226.997 1.672.997 2.701 0 .449.184 1.156.362 1.84.229.881.449 1.724.249 1.923-.353.354-1.704-.354-2.154-.708-.178-.139-.466-.139-.749-.138-.435.001-.86.002-.86-.505z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <g filter={`url(#${id}-ai)`}>
          <path
            clipRule="evenodd"
            d="M-41.743 8.602l-21.603 59.794-7.484-8.969-17.938 14.969-36.09 7.8 11.397 45.261-6.443-42.414 34.043-7.164 15.067-12.573 10.223 12.252 19.956-55.682c2.926 28.841 10.292 82.776 14.531 112.452l-9.262 22.229 33.343 68.707-17.403-59.938v-42.622c-6.926-15.983-10.878-75.477-11.988-103.226l29.39 26.64 44.533 3.995 80.583 35.558c15.983 34.631 10.877 67.668 5.994 79.655l-5.994 26.639c3.996-3.774 12.387-14.385 13.985-26.639 1.599-12.254-4.662-63.267-7.991-87.242-23.443-3.197-67.486-24.863-86.577-35.297l-44.532-7.992C-10.643 24.812-25.12 9.411-34.04 3.531l.388-1.084-2.917-8.166-2.493 6.9c-1.627-.242-2.63.504-2.767 2.557-.07 1.042-.036 2.694.086 4.864zm238.258 14.55L122.363 8.364l61.461 26.74 3.146 31.836 9.545-43.79zm-392.116 42.652l26.26-8.741 4.715-6.057 25.637-6.98-22.111-5.24-7.254 9.318-27.247 17.7z"
            fill="#2AF5C4"
            fillRule="evenodd"
          />
        </g>
        <path d="M0 0h375v616H0V0z" fill={`url(#${id}-aj)`} opacity="0.5" />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-b`}
          x1="-82.749"
          x2="-82.749"
          y1="26.885"
          y2="867.486"
        >
          <stop stopColor="#FF9877" />
          <stop offset="1" stopColor="#FFC6B5" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-e`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-f`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-g`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-h`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-i`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-j`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-k`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-l`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-m`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-n`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-o`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-p`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-q`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-r`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-s`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-t`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-u`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-v`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-w`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-x`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-y`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-z`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-A`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-B`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-C`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-D`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-E`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-F`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-G`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-H`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-I`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-J`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-K`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-L`}
          x1="335.093"
          x2="327.815"
          y1="-336.014"
          y2="773.173"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-M`}
          x1="-158.858"
          x2="-158.858"
          y1="-22.269"
          y2="627.704"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-N`}
          x1="712.718"
          x2="-387.031"
          y1="660.824"
          y2="517.239"
        >
          <stop stopColor="#0E4D89" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-O`}
          x1="369.332"
          x2="-278.163"
          y1="774.578"
          y2="689.255"
        >
          <stop stopColor="#89270E" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-Q`}
          x1="211.674"
          x2="211.674"
          y1="617.622"
          y2="650.626"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-R`}
          x1="97.165"
          x2="97.165"
          y1="617.622"
          y2="650.626"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-S`}
          x1="135.053"
          x2="135.053"
          y1="726.64"
          y2="746.931"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-T`}
          x1="178.209"
          x2="178.209"
          y1="726.006"
          y2="746.297"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-U`}
          x1="175.244"
          x2="175.244"
          y1="674.436"
          y2="692.833"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-V`}
          x1="157.282"
          x2="157.282"
          y1="619.445"
          y2="657.445"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-W`}
          x1="155.604"
          x2="155.604"
          y1="588.277"
          y2="615.215"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-X`}
          x1="126.226"
          x2="126.226"
          y1="625.773"
          y2="642.638"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-Y`}
          x1="153.87"
          x2="153.87"
          y1="674.15"
          y2="687.957"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-Z`}
          x1="139.212"
          x2="139.212"
          y1="674.02"
          y2="694.313"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aa`}
          x1="139.906"
          x2="139.906"
          y1="698.992"
          y2="713.807"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ab`}
          x1="178.209"
          x2="178.209"
          y1="698.992"
          y2="713.807"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-af`}
          x1="74.873"
          x2="103.679"
          y1="702.616"
          y2="450.381"
        >
          <stop stopColor="#FF7EA6" />
          <stop offset="1" stopColor="#8A2164" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ag`}
          x1="406.318"
          x2="376.119"
          y1="922.279"
          y2="570.363"
        >
          <stop stopColor="#FFB995" />
          <stop offset="1" stopColor="#9F5415" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-ah`}
          x1="383.347"
          x2="153.806"
          y1="699.38"
          y2="684.977"
        >
          <stop stopColor="#89270E" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-aj`}
          x1="187.5"
          x2="187.5"
          y1="187.22"
          y2="616"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="2978.22"
          id={`${id}-c`}
          width="3012.83"
          x="-2216.52"
          y="-1068.65"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_6284_32995"
            stdDeviation="400"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="2622.38"
          id={`${id}-d`}
          width="2622.6"
          x="-1012.82"
          y="-1092.72"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_6284_32995"
            stdDeviation="369.477"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="44.654"
          id={`${id}-P`}
          width="55.125"
          x="182.387"
          y="674.129"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.262" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6284_32995"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6284_32995"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="144.339"
          id={`${id}-ac`}
          width="158.644"
          x="77.886"
          y="554.583"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.262" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6284_32995"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6284_32995"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="59.043"
          id={`${id}-ad`}
          width="41.164"
          x="40.811"
          y="549.956"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.262" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6284_32995"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6284_32995"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="50.192"
          id={`${id}-ae`}
          width="33.33"
          x="235.896"
          y="550.459"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.262" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6284_32995"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6284_32995"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="244.163"
          id={`${id}-ai`}
          width="405.296"
          x="-202.19"
          y="-12.309"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.295" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6284_32995"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6284_32995"
            result="shape"
          />
        </filter>
        <clipPath id={`${id}-a`}>
          <path d="M0 0h375v812H0z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}
